import { cloneDeep } from "lodash-es";
import type { ComputedRef } from "vue";
import type { LoggedInMemberResponseDto } from "~/resources/useIsnMemberResource";

/**
 * Get the logged in member
 */
// eslint-disable-next-line import/prefer-default-export
export const useMember = () : ComputedRef<UserDetails | null> => {
  const memberState = useState<LoggedInMemberResponseDto | null | undefined>( "member" );
  return computed( () => cloneDeep( memberState.value?.member ) ?? null );
};
